import * as React from 'react';
import { Button } from './Button';
import './PlaceListBulkBar.css';

interface PlaceListBulkBarProps {
  selectedCount: number;
  actionLabel: string;
  disabled: boolean;
  onAction: () => void;
  onClearSelection: () => void;
}

// 物件一覧で物件を選んでいる間だけ画面下に出す、まとめて操作するためのバー
export const PlaceListBulkBar: React.FC<PlaceListBulkBarProps> = function (props) {
  return (
    <div className="PlaceListBulkBar-container">
      <span>{props.selectedCount} 件選択中</span>
      <Button disabled={props.disabled} onClick={() => props.onAction()}>
        {props.actionLabel}
      </Button>
      <Button color='white' mini disabled={props.disabled} onClick={() => props.onClearSelection()}>
        選択解除
      </Button>
    </div>
  );
};
